/**
 * Syncs "Varieties" selection in product informations with the current URL.
 * Finds the <a> whose href matches the current page URL, marks it as selected,
 * and sets the variety name from the link's title attribute.
 */
(function () {
  const SELECTOR_OPTIONS = '.reves-section-product-informations__variant-options--swatches';
  const SELECTOR_SWATCH = '.reves-section-product-informations__variant-option--swatch';
  const CLASS_SELECTED = 'reves-section-product-informations__variant-option--selected';
  const SELECTOR_SELECTED_VALUE = '.reves-section-product-informations__variant-selected-value';

  function normalizeUrl(pathname, search) {
    return (pathname || '').replace(/\/$/, '') + (search || '');
  }

  function getCurrentNormalizedUrl() {
    return normalizeUrl(window.location.pathname, window.location.search);
  }

  function getLinkNormalizedUrl(link) {
    try {
      const url = new URL(link.getAttribute('href') || '', window.location.href);
      return normalizeUrl(url.pathname, url.search);
    } catch {
      return '';
    }
  }

  /**
   * Path + ?variant=… only — ignores UTM and other params so the selected swatch
   * still matches after navigation (e.g. size change with extra query params).
   */
  function pathAndVariantKey(hrefOrUrl) {
    try {
      const url =
        typeof hrefOrUrl === 'string'
          ? new URL(hrefOrUrl, window.location.href)
          : hrefOrUrl;
      const path = (url.pathname || '').replace(/\/$/, '');
      const variantId = url.searchParams.get('variant');
      return variantId ? `${path}?variant=${variantId}` : '';
    } catch {
      return '';
    }
  }

  function linkMatchesCurrentPage(link) {
    const href = link.getAttribute('href') || '';
    const currentKey = pathAndVariantKey(window.location.href);
    const linkKey = pathAndVariantKey(href);
    if (currentKey && linkKey && currentKey === linkKey) {
      return true;
    }
    return getLinkNormalizedUrl(link) === getCurrentNormalizedUrl();
  }

  function syncVarietiesInSection(section) {
    const optionsContainers = section.querySelectorAll(SELECTOR_OPTIONS);

    optionsContainers.forEach(function (container) {
      const links = container.querySelectorAll(SELECTOR_SWATCH);
      let matchedLink = null;

      links.forEach(function (link) {
        if (linkMatchesCurrentPage(link)) {
          matchedLink = link;
        }
        link.classList.remove(CLASS_SELECTED);
      });

      if (matchedLink) {
        matchedLink.classList.add(CLASS_SELECTED);
        const title = matchedLink.getAttribute('title') || matchedLink.getAttribute('aria-label') || '';
        const variantGroup = container.closest('.reves-section-product-informations__variant-group');
        const selectedValueEl = variantGroup?.querySelector(SELECTOR_SELECTED_VALUE);
        if (selectedValueEl) {
          selectedValueEl.textContent = title ? ' ' + title : '';
        }
      }
    });
  }

  function run() {
    const sections = document.querySelectorAll('.reves-section-product-informations');
    sections.forEach(syncVarietiesInSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('popstate', run);
  window.addEventListener('pagereveal', run);
})();
